import { createSelector } from 'reselect';
import { AppState } from '../../reducers';
import { _get } from '../../../utils/object-prop';
import { IArea } from '../filters/types';

export const selectGeoAddressOfActiveArea = createSelector(
  [
    (state: AppState) => _get(state, 'filters.activeFilters.area.id'),
    (state: AppState) => state.activeParentCityId,
    (state: AppState) => state.parentAreas,
    (state: AppState) => state.filters.areas,
  ],
  (childAreaId, parentAreaId, parentAreas, childAreas) => {
    let find: IArea | undefined;
    if (childAreaId && childAreaId !== '0') {
      find = childAreas.find(a => a.id === childAreaId);
    } else {
      find = parentAreas.find(a => a.id === parentAreaId);
    }

    if (find) {
      return {
        lat: Number(_get(find, 'geo_lat_value', 55.67576)),
        lng: Number(_get(find, 'geo_long_value', 12.56902)),
        zoom_level: find.map_zoom_level,
      };
    }

    return { lat: 55.68500090902244, lng: 12.564903872460933, zoom: 15 };
  },
);
